import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap, tap, filter, take, catchError } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Go } from '@ipreo/northstar';
import { SessionState } from '@ipreo/muni-shared';
import { SessionFacade } from '../facades/session.facade';

const UNAUTHORIZED = 'unauthorized';

@Injectable()
export class SessionResolver
  implements Resolve<boolean>, CanActivate, CanActivateChild {
  constructor(
    private store: Store<Record<string, unknown>>,
    private facade: SessionFacade
  ) {}

  public canActivate(
    route: ActivatedRouteSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.resolve(route);
  }

  public canActivateChild(
    route: ActivatedRouteSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.resolve(route);
  }

  public resolve(
    route: ActivatedRouteSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.getSession().pipe(
      switchMap(() => of(true)),
      catchError((error) => {
        console.log(error);
        this.store.dispatch(new Go({ path: [UNAUTHORIZED] }));
        return of(false);
      })
    );
  }

  private getSession() {
    return this.facade.sessionState$.pipe(
      tap((sessionState) => this.prefetch(sessionState)),
      filter(
        (sessionState) => !!sessionState.session && !!sessionState.session.sub
      ),
      take(1)
    );
  }

  private prefetch(session: SessionState) {
    if (
      !session.error &&
      !session.loading &&
      !session.loaded &&
      !(session.session && session.session.sub)
    ) {
      this.facade.loadSession();
    }
  }
}
